import React from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { ModalFormId } from 'src/components/ModalForms'
import { useModalState } from 'src/Modal/ModalStateContext'
import { EditSVG } from 'src/components/Icons/Basic'
import styled from 'styled-components/macro'
import { PERMISSIONS } from 'src/config/roleConfig'
import {
  useCanPerformActionChecker,
  useHasRequiredPermissions,
} from 'src/app/AppAuth/AppAuth.hooks'
import { SimpleIconButton } from '../../Buttons/SimpleIconButton'

const GridColumnEditIcon = styled(EditSVG)`
  height: 16px;
  width: 16px;
  margin: 5px;
`

export const GridColumnEdit = ({
  modalId,
  permissions,
  capability,
}: {
  modalId: ModalFormId
  permissions: PERMISSIONS[]
  // Role permissions are coarse. When the modal's action is also guarded by an
  // RBAC capability, name it here so the opener is hidden from users the server
  // would reject anyway.
  capability?: CAPABILITY
}): JSX.Element | null => {
  const { openModal } = useModalState()
  const hasPermission = useHasRequiredPermissions(permissions)
  const canPerformAction = useCanPerformActionChecker()

  if (!hasPermission || (capability && !canPerformAction(capability))) {
    return null
  }

  return (
    <SimpleIconButton
      onClick={() => {
        openModal(modalId)
      }}
    >
      <GridColumnEditIcon />
    </SimpleIconButton>
  )
}
